<template>
  <div class="common-nodata">
    <p class="icon"></p>
    <p class="txt">暂无数据</p>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.common-nodata {
  overflow: hidden;
  text-align: center;
  .icon {
    display: block;
    width: 90px;
    height: 90px;
    background: url(./icon-nodata.png) 0 0 no-repeat;
    background-size: 100%;
    margin: 0 auto 4px;
  }
  .txt {
    height: 20px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #999999;
    letter-spacing: 0;
    text-align: center;
    font-weight: 400;
  }
}
</style>
